"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const theme_1 = require("./theme");
const auth0_react_1 = require("@auth0/auth0-react");
const common_styled_components_1 = require("./components/common-styled-components");
const Auth0ProviderWithNavigate_1 = require("./components/Auth0ProviderWithNavigate");
const LoginPage_1 = __importDefault(require("./components/LoginPage"));
const SideContent_1 = require("./components/page-components/SideContent");
const HeaderImage_1 = __importDefault(require("./components/custom/HeaderImage"));
const NavigationContext_1 = require("./contexts/NavigationContext");
const YearContext_1 = require("./contexts/YearContext");
const AppMain = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  ${theme_1.theme.fontNormal};
  background-image: linear-gradient(
    to bottom,
    ${theme_1.theme.colors.blue},
    ${theme_1.theme.colors.blueGradientEnd} 100%
  );
  background-repeat: no-repeat;
  min-height: 100vh;
  height: auto;
  padding: ${theme_1.theme.spacing(4)};
  box-sizing: border-box;

  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    padding: 0;
  }
`;
const LoginInfo = styled_components_1.default.div `
  margin-top: ${theme_1.theme.spacing(5)};
`;
const MainCardContent = styled_components_1.default.div `
  width: 100%;
  max-width: 100%;
  display: grid;
  grid-template-columns: 240px 1fr;

  @media (max-width: ${theme_1.breakpoints.desktop}px) {
    grid-template-columns: 200px 1fr;
  }

  @media (max-width: ${theme_1.breakpoints.tablet}px) {
    grid-template-columns: 100%;
  }
`;
const MainContent = styled_components_1.default.main ``;
const AuthWrapper = ({ children }) => {
    const { isLoading, isAuthenticated } = (0, auth0_react_1.useAuth0)();
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)(AppMain, { children: (0, jsx_runtime_1.jsx)(LoginInfo, { children: "Loading app\u2026" }) }));
    }
    if (!isAuthenticated) {
        return ((0, jsx_runtime_1.jsx)(AppMain, { children: (0, jsx_runtime_1.jsx)(LoginPage_1.default, {}) }));
    }
    return (0, jsx_runtime_1.jsx)("div", { children: children });
};
const App = () => {
    return ((0, jsx_runtime_1.jsx)(Auth0ProviderWithNavigate_1.Auth0ProviderWithNavigate, { children: (0, jsx_runtime_1.jsx)(YearContext_1.YearProvider, { children: (0, jsx_runtime_1.jsx)(NavigationContext_1.NavigationProvider, { children: (0, jsx_runtime_1.jsx)(AuthWrapper, { children: (0, jsx_runtime_1.jsx)(AppMain, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.ContainerCard, { children: (0, jsx_runtime_1.jsxs)(MainCardContent, { children: [(0, jsx_runtime_1.jsx)(SideContent_1.SideContent, {}), (0, jsx_runtime_1.jsxs)(MainContent, { children: [(0, jsx_runtime_1.jsx)(HeaderImage_1.default, { roundTop: false, minHeight: 200 }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {})] })] }) }) }) }) }) }) }));
};
exports.default = App;
